import { Button } from '@hc-frontend/core-ui';

import { useSubsidyCalculator } from './provider';

export function ErrorView() {
  const { reset } = useSubsidyCalculator();
  return (
    <div className="bg-background-50 rounded-2xl px-12-24 py-40-40 flex flex-col items-center justify-center">
      <p className="hc-typography--heading-three text-center animate-in fade-in slide-in-from-bottom-8-8 duration-1000 fill-mode-both">
        Oops! Something Went Wrong
      </p>
      <p className="hc-typography--paragraph-md text-center mt-4-4 animate-in fade-in slide-in-from-bottom-8-8 duration-1000 delay-150 fill-mode-both">
        We&apos;re sorry, an error occurred while calculating your subsidy.
      </p>

      <Button
        variant="primary-card-small"
        className="w-full tablet:w-fit px-32-48 bg-gray-50 text-gray-400 flex justify-center hover:bg-gray-100 mt-24-24 animate-in fade-in slide-in-from-bottom-8-8 duration-1000 delay-300 fill-mode-both"
        type="button"
        onClick={reset}
      >
        Start Over
      </Button>
    </div>
  );
}
